import {
  Autocomplete,
  TextField
} from '@mui/material/';
import React, { useContext, useEffect, useState } from 'react';
import '../App.css';
import DistributionPlot from './DistributionPlot';
import { SystemContext } from '../context';


const CategoricalAnalysisGraph = ({ fetchAPI }) => {

  const { fileName, stringColumns, rawOrCleanData, categoricalCleanedCols, actualFileName } = useContext(SystemContext);
  const [selectedColumn, setSelectedColumn] = useState('');
  const [selectedColumnData, setSelectedColumnData] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(()=>{
    setSelectedColumn('');
    setSelectedColumnData([]);
  },[rawOrCleanData]);

  console.log("this is column name ",selectedColumn);
  const blockStyle = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: '1px solid #ccc',
    fontSize: '1.5em'
  };
  const overlayStyle = {
    position: 'fixed',
    // top: 100,
    // left: 100,
    width: '100%',
    height: '90%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    zIndex: 1000,
  };

  const columnNameOnChange = async (evt, value) => {


    setSelectedColumn(value);

    const temp = []
    temp.push(value)
    const data_sys = {
      "dtype": rawOrCleanData,
      "filename": actualFileName,
      "features": temp
    }
    try {
      setLoading(true);
      const response = await fetchAPI.post('/features', data_sys, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("msal.idtoken")}`,
        }
      });
      setSelectedColumnData(response.data.data[value])
    } catch (error) {
      console.error('Error uploading file:', error);
    } finally {

      setLoading(false);
    }
  }
  const headingStyle = {
    color: '#152C73',
    marginRight: '1rem',
    display: 'flex'
  };

  return (
    <>
      <div style={{ display: 'flex', flexDirection: 'row', marginTop: '1.5rem' }}>
      <h3 style={{ ...headingStyle, marginBottom: '1rem', minWidth: '100px', textAlign: 'left' }}><b>Select Column</b></h3>
        <Autocomplete id="combo-box-demo"
          options={rawOrCleanData === "clean" ? categoricalCleanedCols : stringColumns}
          fullWidth
          style={{ display: 'flex', marginBottom: '10px', width: '40%' }}
          autoHighlight={true}
          onChange={columnNameOnChange}
          value={selectedColumn}
          renderInput={(params) => <TextField {...params}
            label="Select the Categorical Column"
            placeholder='Categorical Columns'
          />}
        />
      </div>

      {selectedColumnData.length > 0 ? <div >

        <div style={{ ...blockStyle, backgroundColor: 'white' }}>
          <DistributionPlot data={selectedColumnData} />
        </div>
      </div> : ""}

      {loading && (
        <div style={overlayStyle}>
          <div className="loader"></div>

        </div>
      )}
    </>
  );
}

export default CategoricalAnalysisGraph;
